import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button } from 'antd';

import { getSupervisor, getShops } from 'actions/asyncActions';
import { supervisorMenuItems } from 'menus';
import Menu from 'components/common/Menu';
import ListTable from 'components/common/ListTable';
import Address from 'components/common/cards/Address';
import City from 'components/common/cards/City';
import Spinner from 'components/common/Spinner';
import withSelectedRows from 'components/common/withSelectedRows';
import withRole from 'components/common/withRole';
import BindShopFilter from 'filters/BindShopFilter';
import { openShopSupervisorBindModal, openUnbindModal } from 'actions/modalActions';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { POST_INSTRUCTION, POST_INSTRUCTIONS } from 'constants/actionTypes';

const stateToProps = state => ({
    supervisor: getSupervisor.selectData(state),
    success: getSupervisor.selectMeta(state).success
});

@withRole
@withSelectedRows
@connect(stateToProps, { openShopSupervisorBindModal, openUnbindModal })
export default class SupervisorShopsCard extends Component {
    columns = [
        {
            title: 'Название',
            dataIndex: 'name',
            key: 'name',
            render: (name, { id }) => <Link to={`/shop/${id}`}>{name}</Link>,
        }, {
            title: 'Торговая сеть',
            dataIndex: ['_embedded', 'network', 'name'],
            key: 'network'
        }, {
            title: 'Город',
            dataIndex: ['_embedded', 'city'],
            key: 'city',
            render: city => <City city={city} />
        }, {
            title: 'Адрес',
            key: 'address',
            render: shop => <Address item={shop} />
        }
    ];

    getUnbindOptins = () => {
        const { selected, supervisor } = this.props;

        return {
            items: selected.map(item => ({
                shop: item.id,
                supervisor: supervisor.id,
                unbind: true,
                type: 'supervisorShop'
            }))
        };
    }

    renderControls() {
        const { openShopSupervisorBindModal, openUnbindModal, supervisor, selected } = this.props;

        return (
            <div>
                <Button type='danger' onClick={() => openUnbindModal(this.getUnbindOptins())} disabled={!selected.length}><MinusOutlined /> Отвязать</Button>
                <Button type='primary' onClick={() => openShopSupervisorBindModal(supervisor)}><PlusOutlined /> Привязать</Button>
            </div>
        );
    }

    render() {
        const { match: { params }, success, rowSelection, supervisor, resetSelected, isAdmin } = this.props;

        return (
            <div>
                <Menu
                    items={supervisorMenuItems(params.id)}
                    controls={isAdmin && this.renderControls()} />
                { success ?
                    <ListTable
                        tableColumns={this.columns}
                        action={getShops}
                        rowSelection={isAdmin && rowSelection}
                        refreshActions={[POST_INSTRUCTION, POST_INSTRUCTIONS]}
                        initialFilters={{ supervisor: supervisor.id }}
                        filterForm={BindShopFilter}
                        onSuccess={resetSelected} />
                    : <Spinner />
                }
            </div>
        );
    }
}
